import React, { useRef } from 'react';
import './Contacto.css';
import emailjs from '@emailjs/browser'; 
import {useTranslation} from "react-i18next";

export default function Contacto() {

    const [traslate,i18n] = useTranslation("contact");


    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_5cn6zsb', 'template_p2bzh51', form.current, 'hj4k4CoP2RcfjX476')
        .then((result) => {
            console.log(result.text);
            alert("Correo enviado")
        }, (error) => {
            console.log(error.text);
            alert("No se pudo mandar el correo")
        });
    };


    return (
        <div className="contacto">
            <div className="info-empresa">
                <h1 className="titulo">	Ing. Levy Merino</h1>
                <ul className="servicios">
                <li><i className="fa fa-mobile"></i>{traslate("mail.cell")}</li>
                <li><i className="fa fa-envelope"></i> levy@merinoo.com.mx</li>
                </ul>
            </div>
            <div className="correo">
                <h2>{traslate("mail.title")}</h2>
                <form ref={form} onSubmit={sendEmail} className="formulario">
                <p>
                    <label>{traslate("mail.name")}</label>
                    <input type="text" name="nombre" required/>
                </p>
                <p>
                    <label>{traslate("mail.mail")}</label>
                    <input type="email" name="email" required/>
                </p>
                <p>
                    <label>{traslate("mail.phone")}</label>
                    <input type="text" name="telefono" required/>
                </p>
                <p className="full">
                    <label>{traslate("mail.message")}</label>
                    <textarea name="mensaje" required></textarea>
                </p>
                <p className="enviar">
                     <button type="submit" value="Send" className="boton-enviar">{traslate("mail.button")}</button>
                    {/* <button type="submit" value="Send" className='boton-enviar'/> */}
                </p>
                </form>
            </div>
      </div>
    );
}